<!--
        Las paginas para administrar Conectores
-->
<div class="page" id="connectors-collection-page">
    <div class="action-bar dark-bg with-tabs">
            <div class="title">Conectores</div>
            <div class="tabs">
                <a class="tab" href="#conectores?estado=A">Activos</a>
                <a class="tab" href="#conectores?estado=I">Inactivos</a>
                <a class="tab" href="#conectores?estado=X">Eliminados</a>
                <a class="tab" href="#conectores?estado=*">Todos</a>
            </div>
            <div class="actions-set">
                <a class="action-btn back" href="#home"></a>
                <a class="action-btn search" href="#"></a>
                <a class="action-btn add" href="#conector?id=nuevo">Agregar un nuevo conector</a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="section" id="conectores">
                <div class="list-content"></div>
            </div>
        </div>
    </div>
</div>

<script>
  import { onMount } from 'svelte'
  import { mountConnectorsCollectionPage } from './ConnectorsCollectionPage'

  onMount(() => {
    mountConnectorsCollectionPage();
  })
</script>
